import { currencyString, isDefined } from '../utils';

export const drawAmountRequiredMessage = 'Enter a cash advance amount.';

export const validateDrawAmount = (
  value: number | undefined,
  minDrawAmount?: number,
  maxDrawAmount?: number,
): true | string => {
  if (value === undefined) { return drawAmountRequiredMessage; }

  if (!isDefined(minDrawAmount) || !isDefined(maxDrawAmount)) {
    return true; // If these are undefined it means the cash advance data call has not completed yet.
  }

  if (value < minDrawAmount || value > maxDrawAmount) {
    return `Enter an amount between ${currencyString(minDrawAmount)} and ${currencyString(maxDrawAmount)}.`;
  }

  return true;
};
